import React from "react";
import { Pagination } from "@ann/web-components";
import { FooterContainer } from "./Footer.styled";

const Footer = ({ 
  currentPage, 
  totalPages, 
  itemsPerPage, 
  totalItems, 
  onPageChange,
  onItemsPerPageChange,
  disabled = false 
}) => {
  return (
    <FooterContainer>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        itemsPerPage={itemsPerPage}
        totalItems={totalItems}
        onPageChange={onPageChange}
        disabled={disabled}
        onItemsPerPageChange={onItemsPerPageChange}
      />
    </FooterContainer>
  );
};

export default Footer; 